<template>
	<page>
		<module>
			<view-list ref="view" work-type="63" dynamic-field :field-sort="false" :view-config="auth('b_defect_items_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="不良品项">
							<c-select name="defects_ids" async multiple @search="searchDefects" ></c-select>
						</m-search-item>
						<m-search-item label="工序">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>
						<m-search-item label="生产人员">
							<c-select name="output_user_ids" async multiple @search="searchOutputUser" ></c-select>
						</m-search-item>
						<m-search-item label="报工审批状态">
							<c-select name="output_states" :options="auditStateDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="时间维度字段">
							<c-select name="date_field" :options="dateFieldOptions" :clear="false"></c-select>
						</m-search-item>
						<m-search-item label="时间范围">
							<c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="时间粒度">
							<c-select name="time_granule" :options="timeGranule" :clear="false"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_defect_items_export')" v-lock="lock('b_defect_items_export')" prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
				defaultSearchData: {
					time_granule: 'DAY',
					date_field: 'create_date',
					start_date: new Date(now.getFullYear(), now.getMonth(), now.getDate()-6).format('yyyy-MM-dd'),
					end_date: new Date().format('yyyy-MM-dd')
				}
			}
		},

		computed: {
			...mapState(['timeGranule','auditStateDic', 'dateFieldOptions']),
			...mapGetters(['freeEdition'])
		},

		methods: {
			
			/*******搜索【不良品项】下拉框信息*****************/
			searchDefects(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICDEFECTS',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>